<template>
    <v-navigation-drawer
        ref="appnavdrawer"
        :value="drawer"
        :mini-variant.sync="mini"
        :floating="mini"
        width="180"
        clipped
        fixed
        class="drawer-transition"
        :class="[
            navdrawer_hover ? 'global-elevation' : '',
        ]"
        disable-resize-watcher
        mini-variant-width="56"
        color="g2"
        :permanent="$vuetify.breakpoint.mdAndUp"
        @input="$emit('update:drawer', $event)"
        @mouseenter.native="navdrawer_mouseon()"
        @mouseleave.native="navdrawer_mouseoff()"
    >
        <v-list
            nav
            dense
            class="d-flex flex-column h-100"
            style="margin-top: 56px; padding-top: 12px"
        >
            <template v-for="(item, index) in permitted_items">
                <v-spacer v-if="item.name === 'spacer'" :key="index"/>
                <v-item-group
                    v-else
                    :key="index"
                    :class="[
                        item.route && isRouteActive(item.route.name) ? 'active' : '',
                        'item-container',
                    ]"
                >
                    <v-divider
                        v-if="item.name === 'divider'"
                        style="margin: 10px 0"
                    ></v-divider>
                    <component
                        :is="
                            bookmarksOfType(item.bookmark_type).length > 0
                                ? 'DropMenu'
                                : 'DummyActivator'
                        "
                        v-else
                        :searchable="bookmarksOfType(item.bookmark_type).length > 8"
                        :show-selected-first="false"
                        :items="bookmarksOfType(item.bookmark_type)"
                        :is-open.sync="bookmark_menus[index]"
                        name-key="name"
                        value-key="id"
                        icon=""
                        :menu-props="{
                            'open-on-hover': true,
                            'offset-x': true,
                            'offset-y': false,
                            'nudge-left': 4,
                            transition: false,
                        }"
                        :highlight-id="getDefaultBookmarkId(item.bookmark_type)"
                        :custom-rules="activeBookmarkRule"
                        :hover-action="onDeleteBookmarkClick"
                        enable-hover-action
                        @input="navigate_bookmark($event)"
                    >
                        <template v-slot="{ on }">
                            <div style="position: relative">
                                <v-list-item
                                    class="navigation-drawer-item"
                                    :class="item.route && isRouteActive(item.route.name) ? item.backgroundColor : ''"
                                    v-on="on"
                                    @click="onItemAction(item)"
                                >
                                    <v-list-item-icon
                                        v-if="item.icon"
                                        class="mr-3"
                                    >
                                        <icon
                                            :icon="item.icon"
                                            :color="
                                                item.route && isRouteActive(item.route.name)
                                                    ? 'main'
                                                    : item.icon_color
                                            "
                                        />
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title :class="item.route && isRouteActive(item.route.name) ? 'subtitle-2 font-weight-bold' : 'body-2 font-weight-regular'">
                                            {{ item.title }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <!--
                </router-link>
                -->
                            </div>
                        </template>
                    </component>
                </v-item-group>
            </template>
        </v-list>
        <ReferralModal
            v-if="isReferralOpen"
            @close="isReferralOpen = false"
        />
    </v-navigation-drawer>
</template>

<script>
import {ref, watch, computed, onMounted} from "@vue/composition-api";
import {$t} from "@/i18n";
import {get} from "@/helpers/get-set";
import BookmarkModule from "../store/modules/bookmark";
import DialogModule from "../store/modules/dialog";
import AppModule from "../store/modules/app";
import AccountModule from "../store/modules/account";
import {Router} from "@/composables/Router";
import RightsModule from "../composables/use-rights";
import DropMenu from "./Legacy_DropMenu";
import DummyActivator from "../components/DummyActivator";
import {getters as bookmarkGetters} from "@/store/modules/bookmark";
import {setCookie, getCookie} from "@/helpers/helpers";
import BookmarkMenu from "../composables/use-bookmark-menu";
import HelpModule from "@/modules/help/help";
import ProjectModule from "@/store/modules/project";
import ReferralModal from "@/components/ReferralModal/Index.vue";

export default {
    name: "AppNavigationDrawer",
    components: {
        ReferralModal,
        DummyActivator,
        DropMenu,
    },
    props: {
        drawer: {
            type: Boolean,
            default: true,
        },
        dark: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, ctx) {
        const router = Router();
        const {can_see_billing_menu} = RightsModule();
        const {deleteBookmark, list: bookmarks, reloadPage} = BookmarkModule();
        const {openConfirmDialog, setConfirmOptions} = DialogModule();
        const {available_accounts, current_account, isFeatureEnabled, getAccount} = AccountModule();
        const {navigate_bookmark, activeBookmarkRule,} = BookmarkMenu();
        const {dashboard_search_bookmarks} = BookmarkModule();
        const appModule = AppModule();
        const {isEventTypeCompany} = ProjectModule();

        const isReferralOpen = ref(false)

        let any_monitoring_enabled = computed(() => available_accounts.value.some((account) => {
            return account && isFeatureEnabled(account.id, "monitoring", false);
        }));

        const saveIsSticky = function (value) {
            setCookie("isSticky", value, 365)
        }

        const toggleIsSticky = () => {
            isSticky.value = !isSticky.value;
            saveIsSticky(isSticky.value);
            ctx.emit("sticky", isSticky.value)
        }

        let bookmark_menus = ref([]);
        let is_mounted = false;
        let navdrawer_hover = ref(false);
        let isHovered = ref(false);
        let isSticky = ref(false);
        let mini = computed({
            get: () => !(isSticky.value || isHovered.value),
            set: val => {
                isHovered.value = !val;
            }
        });

        isSticky.value = getCookie("isSticky") === "true";
        ctx.emit("sticky", isSticky.value)

        const getIconFromName = (name) => {
            if (name === 'suppliers') {
                return 'HeartHandshake'
            } else if (name === 'projects') {
                return 'ClipboardList'
            }
        }


        const items = computed(() => {
            let ret = [
                {
                    title: $t("Dashboard"),
                    name: "dashboard",
                    icon: 'Home',
                    icon_color: "royal-blue",
                    backgroundColor: "royal-blue lighten-1",
                    route: {name: "dashboard"},
                    bookmark_type: "dashboard_search",
                },
                {
                    title: $t("Calendar"),
                    name: "calendar",
                    icon: 'CalendarDays',
                    backgroundColor: "secondary lighten-1",
                    icon_color: "secondary",
                    route: {name: "calendar"},
                    bookmark_type: "calendar",
                },
                {
                    title: $t("Report"),
                    name: "report",
                    icon: 'BarChart',
                    backgroundColor: "pink lighten-1",
                    icon_color: "pink",
                    route: {name: "report"},
                    bookmark_type: "report",
                },
                {
                    title: $t("Monitoring"),
                    name: "monitoring",
                    icon: 'FileSearch2',
                    backgroundColor: "purple lighten-1",
                    icon_color: "purple darken-1",
                    route: {name: "monitoring"},
                    bookmark_type: "monitoring",
                },
                {
                    title: $t("Billing"),
                    name: "billing",
                    icon: 'DollarSign',
                    icon_color: "tretiary",
                    backgroundColor: "tretiary lighten-1",
                    route: {name: "billing"},
                    bookmark_type: "billing",
                },
                {
                    name: "divider",
                },
                {
                    title: $t("Clients"),
                    name: "clients",
                    icon: 'Contact',
                    backgroundColor: "n2",
                    icon_color: "n4",
                    route: {name: "clients_list"},
                    bookmark_type: "client",
                }
            ];

            if (suppliers_in_menu.value) {
                ret.push({
                    title: $t("Suppliers"),
                    name: "suppliers",
                    icon: 'HeartHandshake',
                    backgroundColor: "n2",
                    icon_color: "n4",
                    route: {name: "suppliers_list"},
                    bookmark_type: "supplier"
                })
            }

            if (projects_in_menu.value) {
                ret.push({
                    title: has_event_type_company.value ? $t('Events') : $t("Projects"),
                    name: "projects",
                    icon: 'ClipboardList',
                    backgroundColor: "n2",
                    icon_color: "n4",
                    route: {name: "projects_list"},
                    bookmark_type: "project"
                })
            }

            ret.push({
                title: $t("Members"),
                name: "users",
                icon: 'ScanFace',
                backgroundColor: "n2",
                icon_color: "n4",
                route: {name: "users_list"},
            })

            ret.push({name: "divider"});

            ret.push({
                title: $t("Help"),
                name: "help",
                icon: 'HelpCircle',
                backgroundColor: "n2",
                icon_color: "n4",
                route: {ext: () => HelpModule.getHelpLink("help_mainmenu")},
            });

            if (current_account.value?.data?.referral_visible) {
                ret.push({
                    title: $t("Invite a friend"),
                    name: "referral",
                    icon: 'Heart',
                    backgroundColor: "n2",
                    icon_color: "pink",
                    action: () => isReferralOpen.value = true,
                });
            }

            ret.push({name: "spacer"});

            ret.push({
                title: $t("Settings & Apps"),
                name: "app_store",
                icon: 'Cog',
                backgroundColor: "n2",
                icon_color: "n4",
                route: {name: "app_store"},
            });
            ret.push({
                title: $t("Profile"),
                name: "profile",
                icon: 'User',
                backgroundColor: "n2",
                icon_color: "n4",
                route: {name: "profile"},
            });

            if (current_account.value.abiline) {
                ret.push({name: "divider"});
                ret.push({
                    title: "Abiline",
                    name: "abiline",
                    icon: 'ShieldAlert',
                    backgroundColor: "n2",
                    icon_color: "n4",
                    route: {name: "abiline"},
                });
            }

            ret.push({name: "divider"});
            ret.push({
                title: isSticky.value ? $t("Collapse menu") : $t("Expand menu"),
                name: "stickyToggle",
                icon: isSticky.value ? 'SidebarClose' : 'SidebarOpen',
                backgroundColor: "n2",
                icon_color: "n4",
                action: toggleIsSticky
            });
            return ret;
        });

        const billing_in_menu = computed(() => {
            return can_see_billing_menu()
        });
        const suppliers_in_menu = computed(() => {
            return !!available_accounts.value.find(
                (account) => isFeatureEnabled(account.id, "supplier", false)
            );
        });
        const projects_in_menu = computed(() => {
            return !!available_accounts.value.find(
                (account) => isFeatureEnabled(account.id, "project", false)
            );
        })
        const has_event_type_company = computed(() => {
            return !!available_accounts.value.find(
                (account) => isEventTypeCompany(account.id)
            );
        })

        const permitted_items = computed(() => {
            return items.value.filter((item) => {
                if (item.name === "billing") {
                    return billing_in_menu.value;
                }
                if (item.name === "suppliers") {
                    return suppliers_in_menu.value;
                }
                if (item.name === "abiline") {
                    return !!current_account.value.abiline;
                }
                if (item.name === "monitoring") {
                    return !!any_monitoring_enabled.value;
                }
                return true;
            });
        });
        onMounted(() => {
            is_mounted = true;
        });
        const isMouseOver = function () {
            let mouseover = get(ctx, "refs.appnavdrawer.isMouseover", undefined);
            if (typeof mouseover !== "undefined") {
                return mouseover;
            }
            return false;
        };
        const all_bookmarks_closed = computed(() =>
            bookmark_menus.value.some((x) => !!x)
        );

        const navdrawer_mouseon = function () {
            if (is_mounted) {
                navdrawer_hover.value = true;
                ctx.refs.appnavdrawer.isMouseover = true;
            }
        };
        const navdrawer_mouseoff = function () {
            if (is_mounted) {
                navdrawer_hover.value = false;
                if (!all_bookmarks_closed.value) {
                    ctx.refs.appnavdrawer.isMouseover = false;
                }
            }
        };
        const bookmark_mouseoff = function () {
            if (is_mounted) {
                if (!navdrawer_hover.value) {
                    ctx.refs.appnavdrawer.isMouseover = false;
                }
            }
        };
        watch(all_bookmarks_closed, (x) => {
            // try to close navdrawer if all bookmark menus are closed
            if (!x) {
                bookmark_mouseoff();
            }
        });

        const hasDashboardBookmark = () => {
            const defaultBookmarksJson = localStorage.getItem('defaultBookmarks')
            if (!defaultBookmarksJson) {
                return false
            }

            let defaultBookmarks = {}

            try {
                defaultBookmarks = JSON.parse(defaultBookmarksJson)
            } catch (e) {
                console.error(e)
                return false
            }

            if (!defaultBookmarks.dashboard_search) {
                return false
            }

            const bookmark = dashboard_search_bookmarks.value.find(x => x.id === defaultBookmarks.dashboard_search)
            if (!bookmark) {
                return false
            }

            return true
        }

        const navigate_route = function (route) {
            if (route.name === "dashboard") {
                if (!hasDashboardBookmark()) {
                    let my_route = bookmarkGetters.dashboard_bookmark_route.value;
                    if (my_route) {
                        pushRoute(my_route)
                        return
                    }
                }
            }

            if (!route.name && route.ext) {
                // If no predefined route, source external one.
                appModule.openTargetBlank(route.ext());
            } else {
                pushRoute(route)
            }
        };

        const pushRoute = function (params) {
            appModule.navigateReload(params)
        }
        const bookmarksOfType = function (name) {
            return bookmarks.value.filter((x) => x.type && x.type === name);
        };

        const onDeleteBookmarkClick = (bookmark) => {
            const onDeleteBookmarkConfirm = () => {
                deleteBookmark(bookmark.id);
            };
            setConfirmOptions({
                title: $t("Notice!"),
                text: $t("Are you sure that you want to delete this?"),
                confirm_text: $t("Confirm"),
                cancel_text: $t("Cancel"),
                action: onDeleteBookmarkConfirm,
            });
            openConfirmDialog();
        };
        const isRouteActive = (routeName) => {
            return (
                ctx.root._route.name === routeName ||
                (ctx.root._route.meta.navActiveParent &&
                    ctx.root._route.meta.navActiveParent === routeName)
            );
        };

        const onItemAction = (item) => {
            if (item.route) {
                navigate_route(item.route)
            } else if (item.action) {
                item.action()
            }
        }

        const getDefaultBookmarkId = (bookmarkType) => {
            const localStorageDefaultBookmarks = localStorage.getItem('defaultBookmarks')
            if (!localStorageDefaultBookmarks) {
                return null
            }

            let defaultBookmarks = null
            try {
                defaultBookmarks = JSON.parse(localStorageDefaultBookmarks)
            } catch (e) {
                return null
            }

            return defaultBookmarks[bookmarkType]
        }

        return {
            mini,
            permitted_items,
            isMouseOver,
            navdrawer_mouseon,
            bookmark_menus,
            bookmarks,
            navdrawer_mouseoff,
            navigate_bookmark,
            navigate_route,
            bookmarksOfType,
            activeBookmarkRule,
            onDeleteBookmarkClick,
            isRouteActive,
            isSticky,
            toggleIsSticky,
            isHovered,
            navdrawer_hover,
            appModule,
            onItemAction,
            getDefaultBookmarkId,
            isReferralOpen
        };
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-list--nav {
    padding-left: 0;

    .v-list-item {
        padding: 0;
        padding-left: 16px;
    }
}

::v-deep .v-divider {
    border-color: var(--v-g3-base) !important;
    margin-left: 9px !important;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
    display: none;
}

::v-deep .v-navigation-drawer__content {
    -ms-overflow-style: none;
    scrollbar-width: none;
    display: flex;
    flex-direction: column;
}


.v-list {
    padding-right: 0;

    .v-item-group {
        .navigation-drawer-item {
            // without these, menu items will start juttering on menu close
            -webkit-box-pack: start !important;
            -ms-flex-pack: start !important;
            justify-content: flex-start !important;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            margin-left: 4px;
            margin-right: 4px;
            padding-left: 12px;
            padding-right: 12px;
            border-radius: 8px;
        }
    }
}

.v-navigation-drawer--mini-variant,
.v-navigation-drawer {
    overflow: visible;
}

.drawer-transition {
    transition-property: all;
    will-change: width;
}

.high {
    z-index: 99999;
}

.router-link {
    text-decoration: none;
    color: inherit;
    display: flex;

    &:hover {
        background: #dfe1e6;
    }
}

.sticky-button {
    transition: all 0.3s ease-in-out;
    margin-top: auto;
    margin-left: 12px;

    &.open {
        transform: rotate(180deg);
        margin-left: calc(100% - 48px);
    }
}
</style>
